import { type DirectiveBinding } from 'vue';
import type Product from '~/models/product';

import { useCartStore } from '~/store/cart';

type TrackingInput = {
  product: Product,
  index: number,
  listName?: string,
}

export const useProductImpressionTracking = {
  mounted: (el: HTMLElement, input: DirectiveBinding<TrackingInput>)  => {
    if (input.value) {
      const observer = new IntersectionObserver(
        (entries, observer) => {

          entries.forEach(entry => {

            if (entry.intersectionRatio > 0 && window.dataLayer) {
              /*console.group();
              console.log(input.value.index);
              console.log(input.value.listName);
              console.groupEnd();*/

              pushProductEvent(
                input.value.product,
                'productImpressions',
                input.value.index,
                input.value.listName
              );

              observer.unobserve(entry.target);
            }
          });

        }, {
          threshold: .5, // Wait til we se at least half the observed
        });
      observer.observe(el);
    } else {
      console.warn('Used tracking directive without value');
    }
  },
};

export const pushProductClick = (
  product: Product,
  list = ''
) => {
  const cartStore = useCartStore();
  const payload = {
    event: 'productClick',
    ecommerce: {
      currencyCode: cartStore.cartData.currency,
      click: {
        actionField: {
          list,
        },
        products: [
          {
            id: product.sku,
            ...product.gtmProductValues,
          },
        ],
      },
    },
  };
  pushToDataLayer(payload);
};

export const pushProductEvent = (
  product: Product,
  event = 'productImpressions',
  index = -1,
  listName?: string,
  quantity = -1
) => {
  const cartStore = useCartStore();
  const data = {
    event,
    ecommerce: {
      currencyCode: cartStore.cartData.currency,
      impressions: [ createDataLayerItem(product, index, listName, quantity) ],
    },
  };
  pushToDataLayer(data);
};

export const createDataLayerItem = (
  product: Product,
  index = -1,
  listName?: string,
  quantity = -1
) => {
  const output = {
    id: product.sku,
    feedId: product.sku,
    ...product.gtmProductValues,
  } as any;
  if (listName) {
    output.list = listName;
  }
  if (index >= 0) {
    output.position = index;
  }
  if (quantity >= 0) {
    output.position = quantity;
  }

  return output;
};

export const pushToDataLayer = (data: object) => {
  if (window.dataLayer) {
    window.dataLayer.push(data);
  } else {
    console.warn('attempted useTracking pushDataLayer without datalayer');
  }
};
